import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import theme from './theme/theme';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
// Client-side redirect from mmai.live to www.mmai.live
if (window.location.hostname === 'mmai.live') {
  window.location.replace(`https://www.mmai.live${window.location.pathname}`);
} else {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
      <CssBaseline />
        <App />
      </ThemeProvider>
    </React.StrictMode>
  );
}

